module.exports = __webpack_public_path__ + "media/images/writer/monitor/bg-monitor-a1533ea666188789ee34957679865c76.png";